import axios from "axios";
import React, { useEffect, useState } from "react";
import Pending from "../../../../../assets/images/pending 2.png";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const LearningSessionPending = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/learning_session/pending`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Pending Learning Session"
        image={Pending}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/learning-session/pending`}
        />
      )}
    </>
  );
};

export default LearningSessionPending;
